export default __webpack_public_path__ + "static/media/photo--lg--130.b063efc8.jpg";